const axios = require('axios');
const form = document.querySelector('.subscribe-form');
// const URL_SEND_EMAIL = 'http://localhost:3000/emails/send';
const URL_SEND_EMAIL = 'https://itpixie.herokuapp.com/emails/send';
const notification = document.querySelector(
  'span.subscribe-form__action-hover',
);

const handleSubmit = async e => {
  e.preventDefault();

  const email = e.currentTarget.email.value;
  const cameFrom = e.currentTarget.cameFrom.value;

  const data = {
    email: email,
    cameFrom: cameFrom,
  };

  try {
    await axios.post(URL_SEND_EMAIL, data);
    notification.style.display = 'block';
    notification.style.opacity = 1;
    notification.style.transition = 'opacity 5s';
  } catch (error) {
    console.log(error);
  }
};

form && form.addEventListener('submit', handleSubmit);
